// Builds the medicine list for a given language as: the full English list,
// with any translated (and visible-in-that-language) entries upserted over
// their English counterpart. This way a language that's missing a
// translation for a product still shows it (via the English fallback)
// instead of silently omitting it from search/listings/homepage sections.
//
// `medicines` is the redux `state.medicine.medicines` shape: an array of
// { lang, data } docs, one per language. English is the canonical source —
// every product has a fixedMedicineId there; other languages reference it
// via medicineDetectorId.
export function mergeMedicineList(medicines, lang) {
  if (!medicines || medicines.length === 0) return [];

  const MEn = medicines.find((m) => m.lang === "en");
  if (!MEn || !MEn.data) return [];

  if (!lang || lang === "en") return MEn.data;

  // English-fallback entries get a self-referencing medicineDetectorId so
  // any "lang !== en" cross-reference lookup (view counts, English-name
  // lookup, etc.) still resolves correctly against themselves.
  const merged = MEn.data.map((en) => ({
    ...en,
    medicineDetectorId: en.medicineDetectorId || en.fixedMedicineId,
  }));

  const M = medicines.find((m) => m.lang === lang);
  if (M && M.data && M.data.length > 0) {
    const indexByFixedId = new Map(
      merged.map((en, i) => [en.fixedMedicineId, i])
    );
    M.data.forEach((localized) => {
      const idx = indexByFixedId.get(localized.medicineDetectorId);
      if (idx !== undefined && localized.visible === true) {
        // A localized record has its own, unrelated fixedMedicineId (each
        // language's document gets its own id at creation) — keep the
        // canonical English fixedMedicineId as this slot's identity so
        // every cross-reference/dedup by fixedMedicineId elsewhere still
        // matches, regardless of which language's content occupies it.
        merged[idx] = { ...localized, fixedMedicineId: merged[idx].fixedMedicineId };
      }
    });
  }

  return merged;
}
